import {
  IsFutureDatePipe,
  IsPastDatePipe,
} from '@modules/utils/pipes/dates.pipe';
import {
  NgbActiveModal,
  NgbDatepickerModule,
  NgbModalModule,
} from '@ng-bootstrap/ng-bootstrap';
import { BlockPasteDirective } from '../../directives/block-paste.directive';
import { CommonModule } from '@angular/common';
import { CompliancePipe } from '@tso-pipes/compliance.pipe';
import { CorporationsFlagsPipe } from '@tso-pipes/corporation-flags.pipe';
import { CropModalComponent } from './common/crop-modal/crop-modal.component';
import { CropperComponent } from './common/cropper/cropper.component';
import { CustomCalendarCellBlankImagePipe } from '@tso-pipes/customCalendarCellBlankImage.pipe';
import { CustomCalendarCellContentPipe } from '@tso-pipes/customCalendarCellContent.pipe';
import { CustomCalendarCellImagePipe } from '@tso-pipes/customCalendarCellImage.pipe';
import { CustomCalendarDimensionWidthPipe } from '@tso-pipes/customCalendarDimensionWidth.pipe';
import { CustomCalendarTextFontPipe } from '@tso-pipes/customCalendarTextFont.pipe';
import { DateRangeComponent } from './date-range/date-range.component';
import { DatepickerDirective } from '../../directives/datepicker.directive';
import { DropZoneInputComponent } from './drop-zone-input/drop-zone-input.component';
import { DropZoneInputStyleOneComponent } from '@modules/ui/drop-zone-input-style-one/drop-zone-input-style-one.component';
import { EditedPipe } from '@tso-pipes/edited.pipe';
import { EnumPipe } from '@tso-pipes/enum.pipe';
import { ExtensionDocumentPipe } from '@tso-pipes/extension-document.pipe';
import { ExtensionPipe } from '@tso-pipes/extension.pipe';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FormsModule } from '@angular/forms';
import { GalleryInputComponent } from './gallery-input/gallery-input.component';
import { GalleryModalComponent } from '@modules/ui/common/gallery-modal/gallery-modal.component';
import { GalleryPipe } from '@tso-pipes/gallery.pipe';
import { GalleryRotateCropComponent } from './gallery-rotate-crop/gallery-rotate-crop.component';
import { GalleryUtilComponent } from '@ui/gallery-util/gallery-util.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImagesComponent } from './images/images.component';
import { LibraryComponent } from './common/library/library.component';
import { LoaderComponent } from './loader/loader.component';
import { LoaderService } from '@services/layout/loader.service';
import { MediaInputComponent } from './media-input/media-input.component';
import { MediaPipe } from '@tso-pipes/media.pipe';
import { MeridianComponent } from './meridian/meridian.component';
import { ModifyFontSizePrintPipe } from '@tso-pipes/modify-font-size-print.pipe';
import { NavbarBDPipe } from '@tso-pipes/navbarBD.pipe';
import { NewsletterHtmlPipe } from '@tso-pipes/newsletterHtml.pipe';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NoDataComponent } from './no-data/no-data.component';
import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ReactiveFormsModule } from '@angular/forms';
import { RegexPipe } from '@tso-pipes/regex.pipe';
import { RouterModule } from '@angular/router';
import { SecondsPipe } from '@tso-pipes/seconds.pipe';
import { SelectorComponent } from './selector/selector.component';
import { SortableDirective } from '../../directives/tables/sortable.directive';
import { ThumbnailPipe } from '@tso-pipes/thumbnail.pipe';
import { TruncateDecimalPipe } from '@tso-pipes/truncate-decimal.pipe';
import { TruncatePipe } from '@tso-pipes/truncate.pipe';
import { UnsplashComponent } from '@modules/ui/common/unsplash/unsplash.component';
import { UrlifyPipe } from '@tso-pipes/urlify.pipe';
import { UserCorporationPipe } from '@tso-pipes/user-corporation.pipe';
import { UserMediaComponent } from '@modules/ui/common/user-media/user-media.component';

@NgModule({
  declarations: [
    SortableDirective,
    DatepickerDirective,
    BlockPasteDirective,
    LoaderComponent,
    PagetitleComponent,
    ImagesComponent,
    FileUploadComponent,
    NoDataComponent,
    CropModalComponent,
    NewsletterHtmlPipe,
    //
    TruncatePipe,
    TruncateDecimalPipe,
    SecondsPipe,
    NavbarBDPipe,
    UrlifyPipe,
    GalleryInputComponent,
    DropZoneInputComponent,
    GalleryModalComponent,
    UserMediaComponent,
    UnsplashComponent,
    MediaInputComponent,
    ThumbnailPipe,
    MediaPipe,
    EditedPipe,
    CorporationsFlagsPipe,
    GalleryPipe,
    EnumPipe,
    ExtensionPipe,
    ExtensionDocumentPipe,
    RegexPipe,
    UserCorporationPipe,
    CustomCalendarCellContentPipe,
    CustomCalendarTextFontPipe,
    CustomCalendarDimensionWidthPipe,
    CustomCalendarCellImagePipe,
    CustomCalendarCellBlankImagePipe,
    ModifyFontSizePrintPipe,
    CompliancePipe,
    IsFutureDatePipe,
    IsPastDatePipe,
    //
    PdfViewerComponent,
    DropZoneInputStyleOneComponent,
    CropperComponent,
    LibraryComponent,
    DateRangeComponent,
    SelectorComponent,
    MeridianComponent,
    GalleryRotateCropComponent,
    GalleryUtilComponent,
  ],
  exports: [
    SortableDirective,
    DatepickerDirective,
    BlockPasteDirective,
    LoaderComponent,
    PagetitleComponent,
    ImagesComponent,
    FileUploadComponent,
    NoDataComponent,
    //
    TruncatePipe,
    TruncateDecimalPipe,
    SecondsPipe,
    MediaPipe,
    UrlifyPipe,
    EditedPipe,
    CorporationsFlagsPipe,
    GalleryPipe,
    NavbarBDPipe,
    EnumPipe,
    ExtensionPipe,
    ExtensionDocumentPipe,
    RegexPipe,
    UserCorporationPipe,
    CustomCalendarCellContentPipe,
    CustomCalendarTextFontPipe,
    CustomCalendarDimensionWidthPipe,
    CustomCalendarCellImagePipe,
    CustomCalendarCellBlankImagePipe,
    ModifyFontSizePrintPipe,
    IsFutureDatePipe,
    IsPastDatePipe,
    //
    GalleryInputComponent,
    DropZoneInputComponent,
    GalleryModalComponent,
    MediaInputComponent,

    PdfViewerComponent,
    DropZoneInputStyleOneComponent,
    DateRangeComponent,
    SelectorComponent,
    MeridianComponent,
    GalleryRotateCropComponent,
    UnsplashComponent,
    GalleryUtilComponent,
    CompliancePipe,
    NewsletterHtmlPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgxDropzoneModule,
    NgbNavModule,
    NgbModalModule,
    ImageCropperModule,
    PdfViewerModule,
    NgbDatepickerModule,
    NgSelectModule,
    NgxSliderModule,
  ],
  providers: [LoaderService, NgbActiveModal],
})
export class UiModule {}
